/// <reference types="./style_guidelines.d.mts" />
import * as $bright from "../../../../bright/bright.mjs";
import * as $user from "../../../../common/data/user.mjs";
import { User } from "../../../../common/data/user.mjs";
import * as $timestamp_ from "../../../../common_common/gleam/time/timestamp/extra.mjs";
import * as $button from "../../../../ds/ds/components/button.mjs";
import * as $l from "../../../../ds/ds/components/layout.mjs";
import * as $pp from "../../../../ds/ds/components/profile_picture.mjs";
import * as $table from "../../../../ds/ds/components/table.mjs";
import * as $icons from "../../../../ds/ds/icons.mjs";
import * as $bool from "../../../../gleam_stdlib/gleam/bool.mjs";
import * as $list from "../../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../../gleam_stdlib/gleam/option.mjs";
import { Some } from "../../../../gleam_stdlib/gleam/option.mjs";
import * as $timestamp from "../../../../gleam_time/gleam/time/timestamp.mjs";
import * as $el from "../../../../lustre/lustre/element.mjs";
import * as $e from "../../../../lustre/lustre/event.mjs";
import * as $css from "../../../../sketch/sketch/css.mjs";
import * as $h from "../../../../sketch_lustre/sketch/lustre/element/html.mjs";
import * as $model from "../../../data/model.mjs";
import * as $state from "../../../data/model/state.mjs";
import * as $msg from "../../../data/msg.mjs";
import * as $common from "../../../frontend/view/common.mjs";
import * as $s from "../../../frontend/view/styles/organization.mjs";
import * as $ps from "../../../frontend/view/styles/proposals.mjs";
import { Ok, toList } from "../../../gleam.mjs";

function no_guideline() {
  let msg = "Add a new style guidelines to instruct how the AI should respond.";
  return $table.empty_table(msg, 10);
}

function to_full_date(date) {
  let date$1 = $timestamp_.to_locale_full_date(date);
  return $el.text(date$1);
}

function pre_line(content) {
  let _pipe = $css.class$(toList([$css.white_space("pre-line")]));
  return $h.div(_pipe, toList([]), toList([$h.text(content)]));
}

function profile_picture(user) {
  let name = user.name;
  let picture = user.picture;
  let initials = user.initials;
  return $l.row(
    toList([$l.gap(8), $l.align("center")]),
    toList([]),
    toList([$pp.from_user(picture, initials, new $pp.Medium()), $el.text(name)]),
  );
}

function body(state) {
  let is_no_content = $list.is_empty(state.organization.style_guidelines);
  return $bool.lazy_guard(
    is_no_content,
    no_guideline,
    () => {
      return $table.body(
        $list.map(
          state.organization.style_guidelines,
          (guideline) => {
            let creator = $state.find_user(state, new Some(guideline.creator));
            if (creator instanceof Ok) {
              let user = creator[0];
              let _pipe = $table.row(
                toList([
                  $table.cell($el.text(guideline.name)),
                  $table.cell(profile_picture(user)),
                  $table.cell(pre_line(guideline.content)),
                  $table.cell(to_full_date(guideline.created_at)),
                  $table.cell(to_full_date(guideline.updated_at)),
                  (() => {
                    let _pipe = $table.cell(
                      (() => {
                        let on_delete = new $msg.UserDeletedStyleGuideline(
                          guideline.id,
                        );
                        let on_delete$1 = $e.on_click(on_delete);
                        return $ps.trash_icon_button(
                          toList([on_delete$1]),
                          toList([$icons.tiny($icons.trash())]),
                        );
                      })(),
                    );
                    let _pipe$1 = $table.justify(_pipe, "end");
                    return $table.stop_cell_propagation(_pipe$1);
                  })(),
                ]),
              );
              return $table.on_click(
                _pipe,
                new $msg.UserClickedOnStyleGuideline(guideline.id),
              );
            } else {
              return $table.none();
            }
          },
        ),
      );
    },
  );
}

export function view(model) {
  let state = $bright.state(model);
  return $l.fragment(
    toList([
      $s.style_guidelines(
        toList([]),
        toList([
          $common.underlined_title(
            toList([]),
            toList([$el.text("Style Guidelines"), $common.separator()]),
          ),
          $s.add_style_guideline(
            toList([]),
            toList([
              $button.primary(
                toList([$e.on_click(new $msg.UserClickedOnAddStyleGuideline())]),
                toList([
                  $icons.small($icons.add()),
                  $h.text("Add new guideline"),
                ]),
              ),
            ]),
          ),
          $table.table(
            toList([]),
            toList([
              $table.headers(
                toList([
                  (() => {
                    let _pipe = $table.header("Name");
                    return $table.fit(_pipe);
                  })(),
                  (() => {
                    let _pipe = $table.header("Creator");
                    return $table.fit(_pipe);
                  })(),
                  $table.header("Content"),
                  (() => {
                    let _pipe = $table.header("Creation date");
                    return $table.fit(_pipe);
                  })(),
                  (() => {
                    let _pipe = $table.header("Modification date");
                    return $table.fit(_pipe);
                  })(),
                  $table.header(""),
                ]),
              ),
              body(state),
            ]),
          ),
        ]),
      ),
    ]),
  );
}
